import { render, staticRenderFns } from "./MainSection.vue?vue&type=template&id=2799ea6d&scoped=true"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"
import style0 from "./MainSection.vue?vue&type=style&index=0&id=2799ea6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799ea6d",
  null
  
)

export default component.exports